import React from 'react';
import { Body, Divider } from '@walmart-web/livingdesign-components';

import styles from './styles.module.css';
import Accordion from '../../../../components/Accordian';

type Props = {
  title: string;
  body: string;
  defaultExpanded?: boolean;
};

const FaqAccordionItem: React.FC<Props> = ({
  title,
  body,
  defaultExpanded
}) => {
  return (
    <>
      <Accordion
        accordianTitle={
          <Body size="large" weight={700}>
            {title}
          </Body>
        }
        extraClasses={{
          summaryContainer: styles.faqQuestion,
          summaryText: styles.faqQuestionText
        }}
        accordianDetails={
          <Body size="medium" UNSAFE_className={styles.bodyText}>
            {body}
          </Body>
        }
        defaultExpanded={defaultExpanded}
      />
      <Divider />
    </>
  );
};

export default FaqAccordionItem;
